import * as React from "react";
import {
  Edit,
  SimpleForm,
  SelectInput,
  required,
  ReferenceField,
  TextField,
  ArrayInput,
  SimpleFormIterator,
  TextInput,
  maxValue,
  minValue,
  SimpleShowLayout,
  NumberInput,
  ReferenceInput,
  AutocompleteInput,
  BooleanInput,
  useTranslate,
} from "react-admin";
import { GAS_BRAND_MERCHANT_STATUSES } from "@local/app/constants/index.js";
import { Title, CustomToolbar } from "../../shared/components/index.js";

const editGasBrandMerchant = () => {
  const t = useTranslate();

  const renderOptionText = (record) => (
    <span key={record.id}>
      <img
        src={record?.url}
        width={15}
        height={15}
        style={{ marginRight: "5px" }}
      />
      {record.name}
    </span>
  );

  return (
    <Edit
      title={<Title source="name" />}
      mutationMode="pessimistic"
      redirect="show"
    >
      <SimpleForm toolbar={<CustomToolbar />}>
        <SimpleShowLayout>
          <ReferenceField source="merchant_id" reference="Merchant" link="show">
            <TextField source="name" helpers="Merchant" />
          </ReferenceField>
          <ReferenceField
            source="gas_brand_id"
            reference="GasBrand"
            link="show"
          >
            <TextField source="name" />
          </ReferenceField>
        </SimpleShowLayout>
        <ReferenceInput source="logo_file_id" reference="File">
          <AutocompleteInput
            inputText={(record) => record.name}
            emptyText={t("resources.GasBrandMerchant.source.no_value")}
            optionText={renderOptionText}
            optionValue="id"
            debounce={10}
            filterToQuery={(searchText) => ({ name: searchText })}
          />
        </ReferenceInput>
        <BooleanInput source="partner_gas_brand" />
        <NumberInput
          sx={{ width: "14%" }}
          source="priority"
          min={0}
          max={32000}
          validate={[required(), minValue(0), maxValue(32000)]}
          defaultValue={0}
        />
        <SelectInput
          source="status"
          validate={[required()]}
          choices={Object.keys(GAS_BRAND_MERCHANT_STATUSES).map((status) => ({
            id: status,
            name: `resources.GasBrandMerchant.source.status.${status}`,
          }))}
        />
        <ArrayInput source="fuels">
          <SimpleFormIterator inline disableClear>
            <TextInput
              source="name"
              label="resources.GasBrandMerchant.fuels.name"
              inputProps={{ maxLength: 55, minLength: 1 }}
              validate={[required()]}
            />
            <NumberInput
              source="regular_price"
              label="resources.GasBrandMerchant.fuels.regular_price"
              validate={[required(), maxValue(2147483647), minValue(0)]}
            />
            <NumberInput
              source="discount_price"
              label="resources.GasBrandMerchant.fuels.discount_price"
              validate={[required(), maxValue(2147483647), minValue(0)]}
            />
            <SelectInput
              source="status"
              label="resources.GasBrandMerchant.fuels.status"
              validate={[required()]}
              choices={Object.keys(GAS_BRAND_MERCHANT_STATUSES).map(
                (status) => ({
                  id: status,
                  name: `resources.GasBrandMerchant.source.status.${status}`,
                })
              )}
            />
          </SimpleFormIterator>
        </ArrayInput>
      </SimpleForm>
    </Edit>
  );
};

export default editGasBrandMerchant;
